<!--
 * @Description: 
 * @Date: 2022-03-03 11:07:27
-->
<template>
  <!-- <dic-select
    @dic-select-obj="change"
    :fuzzyDef="listPersonTagForSelect"
    :prop="{
      label: 'user_tag',
      code: 'user_tag'
    }"
    :ajaxQueryObj="{
      projectId: $store.state.homeProject.id
    }"
    ajaxQuery="userTagName"
    placeholder="请输入人员标签"
    :collapseTags="true"
    :multiple="true"
    clearable
  ></dic-select> -->
  <el-autocomplete
    :maxlength="30"
    clearable
    placeholder="请输入关键字"
    v-model.trim="userTagName"
    :debounce="0"
    :fetch-suggestions="querySearch"
    @select="
      item => {
        userTagName = item.value;
      }
    "
    @input="change"
  ></el-autocomplete>
</template>

<script>
// import { projectPersonnelManagement } from '@/api/ajax';
export default {
  name: 'select-person-label',
  components: {},
  props: {
    dataObj: {
      type: Object,
      default: () => ({})
    },
    dataObjKey: {
      type: String,
      default: 'userTag'
    }
  },
  data() {
    return {
      userTagName: ''
      // listPersonTagForSelect: async data => {
      //   const no = [{ user_tag: '未设置' }];
      //   try {
      //     const res = await projectPersonnelManagement.listPersonTagForSelect(
      //       data
      //     );
      //     const list = res.data.data.list;
      //     res.data.data.list = [
      //       ...new Set([...(list || []), ...no].map(({ user_tag }) => user_tag))
      //     ].map(user_tag => ({ user_tag }));
      //     return res;
      //   } catch (error) {
      //     return no;
      //   }
      // }
    };
  },
  methods: {
    querySearch(queryString, cb) {
      cb(
        [{ value: '未设置' }].filter(
          i => !queryString || i.value.indexOf(queryString) > -1
        )
      );
    },
    change(val) {
      // let value = val.user_tag;
      // if (Array.isArray(val)) {
      //   value = val.map(i => i.user_tag).join(',');
      // }
      // this.dataObj[this.dataObjKey] = value;
      // this.dataObj['notSet'] = (value || '').indexOf('未设置') > -1 ? 1 : 0;

      this.dataObj[this.dataObjKey] = val;
      this.dataObj.notSet = val === '未设置' ? 1 : 0;
      this.$emit('change');
    }
  }
};
</script>

<style></style>
